<template>
  <tbody role="group">
    <EntityRow
      :item="document"
      :expanded="expanded"
      @toggle="expandCopypages()"
      @select="(shiftSelect, selected) => { shiftSelect ? $emit('shiftSelect', docIndex, selected) : selectDocument([document]) }"
      :selected="document.copypages ? isEveryDocumentSelected(copypages) : isEveryDocumentSelected([document])"
      v-bind="$attrs"
      :viewport="viewport"
    />
    <template v-if="expanded">
      <EntityRow
        v-for="(doc, idx) in copypages"
        :key="`${doc.node_id}_${doc.uri_id}_${idx}`"
        :item="doc"
        @select="(shiftSelect, selected) => { shiftSelect ? $emit('shiftSelect', docIndex, selected) : selectDocument([doc]) }"
        :selected="isEveryDocumentSelected([doc])"
        v-bind="$attrs"
        :viewport="viewport"
      />
    </template>
  </tbody>
</template>

<script>
import { defineComponent } from 'vue';
import { mapBrowserMutations, mapBrowserGetters, mapBrowserActions } from '@/store';
import EntityRow from '@/components/browser/documents/EntityRow.vue';

export default defineComponent({
  inheritAttrs: false,
  props: {
    document: {
      type: Object,
      required: true,
    },
    docIndex: Number,
    viewport: {
      type: Object,
      required: true,
    },
  },
  components: {
    EntityRow,
  },
  data() {
    return {
      expanded: false,
      loadedCopypages: false,
    };
  },
  computed: {
    ...mapBrowserGetters([
      'isEveryDocumentSelected',
    ]),
    copypages() {
      if (this.document.copypages) {
        return this.document.copypages;
      }

      return [];
    },
  },
  methods: {
    ...mapBrowserMutations([
      'toggleDocuments',
      'setShiftSelectAnchor',
    ]),
    ...mapBrowserActions([
      'fetchDocumentCopypages',
    ]),
    selectDocument(docs) {
      this.toggleDocuments(docs);
      this.setShiftSelectAnchor(this.docIndex);
    },
    async expandCopypages() {
      if (!this.expanded) {
        await this.fetchDocumentCopypages(this.document);

        if (this.isEveryDocumentSelected([this.document]) && !this.loadedCopypages) {
          this.selectDocument(this.document.copypages);
          this.loadedCopypages = true;
        }
      }

      this.expanded = !this.expanded;
    },
  },
});
</script>
